import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="buylist-review"
export default class extends Controller {
  static targets = ["itemRow", "statusSelect", "conditionField", "rejectionField", "payoutTotal", "acceptedCount", "rejectedCount"]

  connect() {
    this.updateSummary()
  }

  statusChanged(event) {
    const row = event.target.closest("[data-buylist-review-target='itemRow']")
    if (!row) return

    const status = event.target.value
    const conditionField = row.querySelector("[data-buylist-review-target='conditionField']")
    const rejectionField = row.querySelector("[data-buylist-review-target='rejectionField']")

    // Show/hide conditional fields
    if (conditionField) {
      conditionField.classList.toggle("hidden", status !== "adjusted")
    }
    if (rejectionField) {
      rejectionField.classList.toggle("hidden", status !== "rejected")
    }

    this.updateSummary()
  }

  acceptAll(event) {
    event.preventDefault()
    this.statusSelectTargets.forEach(select => {
      select.value = "accepted"
      select.dispatchEvent(new Event("change"))
    })
    this.updateSummary()
  }

  rejectAll(event) {
    event.preventDefault()
    this.statusSelectTargets.forEach(select => {
      select.value = "rejected"
      select.dispatchEvent(new Event("change"))
    })
    this.updateSummary()
  }

  updateSummary() {
    let payout = 0
    let accepted = 0
    let rejected = 0

    this.itemRowTargets.forEach(row => {
      const select = row.querySelector("[data-buylist-review-target='statusSelect']")
      if (!select) return

      const status = select.value
      const offerCents = parseInt(row.dataset.offerCents) || 0
      const quantity = parseInt(row.dataset.quantity) || 1

      if (status === "accepted" || status === "adjusted") {
        payout += offerCents * quantity
        accepted++
      } else if (status === "rejected") {
        rejected++
      }
    })

    if (this.hasPayoutTotalTarget) {
      this.payoutTotalTarget.textContent = `$${(payout / 100).toFixed(2)}`
    }
    if (this.hasAcceptedCountTarget) {
      this.acceptedCountTarget.textContent = accepted
    }
    if (this.hasRejectedCountTarget) {
      this.rejectedCountTarget.textContent = rejected
    }
  }
}
